class Menu {
	constructor() {
		this.primaryNavigation = document.getElementById("primary-navigation");
		this.overlays = this.primaryNavigation.querySelectorAll("[data-overlay]");

		this.desktopPrimaryNavigation = document.getElementById("desktop-primary-navigation");
		this.mobilePrimaryNavigation = document.getElementById("mobile-primary-navigation");

		this.desktopLinks = this.desktopPrimaryNavigation.querySelectorAll('a[role="menuitem"]');

		if (this.mobilePrimaryNavigation) {
			this.mobileMenuToggles = document.querySelectorAll("[aria-controls='mobile-primary-navigation']");
			this.mobileMenuLevelContainer = this.mobilePrimaryNavigation.querySelector("[data-mobile-menu-level-container]");
			this.mobileMenuItemTemplate = document.getElementById("mobile-menu-item-template");
			this.mobileMenuDropdownTemplate = document.getElementById("mobile-menu-dropdown-template");
			this.mobileMenuLevelOneElements = this.mobilePrimaryNavigation.querySelectorAll('[data-level="1"]');
			this.mobileMenuBackArrow = this.mobilePrimaryNavigation.querySelector("[data-back-arrow]");

			this.mobileMenuLevelData = JSON.parse(this.mobilePrimaryNavigation.dataset.levels);
			this.mobileMenuLevelPath = [];
		}

		this.init();
	}

	openDropdown(link) {
		const depth = parseInt(link.dataset.depth, 10);
		const depthSelector = (d) => `[data-depth="${d}"][aria-expanded="true"]`;

		const depthsToCloseSelectors = [depthSelector(depth)];
		for (let i = 4; i > 2; i -= 1) {
			if (depth <= i) depthsToCloseSelectors.push(depthSelector(i));
		}

		const depthsToCloseEles = this.desktopPrimaryNavigation.querySelectorAll(depthsToCloseSelectors.join(","));
		depthsToCloseEles.forEach((dropdown) => dropdown.setAttribute("aria-expanded", "false"));
		const dropdown = document.getElementById(link.getAttribute("aria-controls"));
		if (dropdown) {
			const linkOffset = parseInt(link.offsetTop, 10);
			const container = link.closest('[aria-expanded="true"]');
			let containerOffset = 0;
			if (container) {
				containerOffset = parseInt(window.getComputedStyle(link).getPropertyValue("--offsetTop"), 10);
			}
			const dropdownPaddingTop = parseInt(window.getComputedStyle(dropdown).getPropertyValue("padding-top"), 10);
			dropdown.style.setProperty("--offsetTop", `${linkOffset + containerOffset - dropdownPaddingTop}px`);
			dropdown.setAttribute("aria-expanded", "true");
		}
	}

	closeDropdowns() {
		this.desktopPrimaryNavigation
			.querySelectorAll('[aria-expanded="true"][data-depth="1"]')
			.forEach((dropdown) => dropdown.setAttribute("aria-expanded", "false"));
	}

	initDesktop() {
		this.desktopLinks.forEach((link) => {
			if (link.getAttribute("data-top-level") && !link.getAttribute("aria-haspopup")) {
				link.addEventListener("mouseenter", () => this.closeDropdowns());
			} else {
				link.addEventListener("mouseenter", () => this.openDropdown(link));
			}
			const dropdown = document.getElementById(link.getAttribute("aria-controls"));
			if (dropdown) dropdown.addEventListener("mouseleave", this.closeDropdowns(dropdown));
		});
	}

	toggleMobileMenu() {
		const isExpanded = this.mobilePrimaryNavigation.getAttribute("aria-expanded") === "true";
		this.mobilePrimaryNavigation.setAttribute("aria-expanded", `${!isExpanded}`);
		document.documentElement.classList.toggle("overflow-clip", !isExpanded);
		this.mobileMenuToggles.forEach((toggle) => {
			toggle.setAttribute("aria-expanded", `${!isExpanded}`);
		});
		this.mobileMenuLevelPath = [];
		this.renderMobileMenuLevel();
	}

	get activeLevelData() {
		return this.mobileMenuLevelPath.reduce((currentLevelData, index) => {
			if (!currentLevelData || !currentLevelData[index] || !currentLevelData[index].items) {
				return null;
			}
			return currentLevelData[index].items;
		}, this.mobileMenuLevelData);
	}

	renderMobileMenuLevel() {
		this.mobileMenuLevelOneElements.forEach((ele) =>
			ele.toggleAttribute("hidden", this.mobileMenuLevelPath.length > 0)
		);
		this.mobileMenuBackArrow.toggleAttribute("hidden", this.mobileMenuLevelPath.length === 0);
		this.mobileMenuLevelContainer.innerHTML = "";
		this.activeLevelData.forEach((ele, index) => {
			const template =
				(ele.items && ele.items.length) > 0 ? this.mobileMenuDropdownTemplate : this.mobileMenuItemTemplate;
			const menuNode = template.content.cloneNode(true);
			menuNode.firstElementChild.style.setProperty("--_animationDelay", `${0.08 * index}s`);
			const menuLabel = menuNode.querySelector("[data-menu-label]");
			if (menuLabel) menuLabel.innerText = ele.label;

			const menuLink = menuNode.querySelector("[data-link]");
			if (menuLink) {
				if (ele.link) {
					menuLink.setAttribute("href", ele.link);
				} else {
					menuLink.classList.add("text-base", "mt-9");
				}
			}

			const menuButton = menuNode.querySelector("[data-next-level]");
			if (menuButton)
				menuButton.addEventListener("click", () => {
					this.mobileMenuLevelPath.push(index);
					this.renderMobileMenuLevel();
				});

			this.mobileMenuLevelContainer.appendChild(menuNode);
		});

		if (this.mobileMenuLevelPath.length === 1) {
			if (this.mobileMenuLevelData[this.mobileMenuLevelPath[0]]) {
				const { dropLabel, dropLink } = this.mobileMenuLevelData[this.mobileMenuLevelPath[0]];
				if (dropLabel && dropLink) {
					const dropTemplate = this.mobileMenuItemTemplate.content.cloneNode(true);
					const dropMenu = dropTemplate.querySelector("[data-link]");
					dropMenu.innerText = dropLabel;
					dropMenu.setAttribute("href", dropLink);
					this.mobileMenuLevelContainer.prepend(dropTemplate);
				}
			}
		}
	}

	initMobile() {
		if (!this.mobileMenuToggles) return;
		this.mobileMenuToggles.forEach((toggle) => toggle.addEventListener("click", this.toggleMobileMenu.bind(this)));
		this.mobileMenuBackArrow.addEventListener("click", () => {
			this.mobileMenuLevelPath.pop();
			this.renderMobileMenuLevel();
		});
	}

	init() {
		this.overlays.forEach((overlay) => {
			overlay.addEventListener("mouseenter", this.closeDropdowns.bind(this));
			overlay.addEventListener("click", this.toggleMobileMenu.bind(this));
		});
		this.initDesktop();
		this.initMobile();
	}
}

// eslint-disable-next-line no-new
new Menu();
